<template>
  <modal back="edit-design" :title="$t('customization.editMotif')">
    <design-list
      @selectDesign="closeModalAfter(() => editDesign($event))"
    ></design-list>
  </modal>
</template>
<script>
import DesignList from './DesignList';
import Modal from '../../components/DesignModal';
import { TrackingMixin } from '../../mixins/gtm-tracking';
import Redirect from '@/mixins/redirect';
import ActiveElement from '@/mixins/activeElement';
export default {
  name: 'DesignListEdit',
  components: {
    DesignList,
    Modal
  },
  mixins: [TrackingMixin, Redirect, ActiveElement],
  methods: {
    editDesign(design) {
      this.updateElement({
        src: design.thumbnail,
        id: design.id
      });
      this.trackEvent({
        action: 'ChangeMotif'
      });
    }
  }
};
</script>
